import { debugToggleByType } from 'features/internal/internal-settings.slice';
import { RootState } from './store';
import { useTypedSelector } from 'common/hooks/store';
import PageBreadcrumbBar from 'features/topbar/breadcrumb-bar/breadcrumbBar';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { ToggleType } from 'features/internal/internal.models';
import { selectIsSidebarOpen } from 'features/sidebar/sidebarSlice';

const PageContent: React.FC = () => {
  const isNewSideBarEnabledDebugToggle = useSelector((state: RootState) =>
    debugToggleByType(state, ToggleType.DisplayNewSideBar)
  );

  const isSidebarOpenLegacy = useTypedSelector(
    (state: RootState) => state.sidebar.isSidebarOpen
  );

  const isSidebarOpen = useSelector(selectIsSidebarOpen);
  return (
    <>
      <div
        className={` bg-neutral-100 font-sans transition-all ${
          ((isNewSideBarEnabledDebugToggle?.enabled ?? false) &&
            isSidebarOpen) ||
          ((!isNewSideBarEnabledDebugToggle?.enabled ?? false) &&
            isSidebarOpenLegacy)
            ? 'md:ml-72'
            : 'md:ml-18'
        }`}
      >
        <div className="mx-auto px-2 md:px-4 py-4">
          <PageBreadcrumbBar />
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};

export default PageContent;
